/**
 * Frontend-only withdrawal source configuration.
 * Change WITHDRAWAL_SOURCE here to allow other wallets in the UI later.
 */
export const WITHDRAWAL_SOURCE = 'Overall Asset';
